import { patientMeasurementTypes } from './measurementTypes';

// Form identifiers stay separate from API types. Values use the displayed units.
export const clinicalMeasurementTypes = [
    {
        type: 'lipid-profile',
        apiType: 'M_LIPIDS',
        labelKey: 'userPage.measurements.lipids',
        fields: [
            { field: 'ldl', label: 'LDL', unit: 'mg/dL' },
            { field: 'hdl', label: 'HDL', unit: 'mg/dL' },
            {
                field: 'totalCholesterol',
                labelKey: 'userPage.measurements.totalCholesterol',
                unit: 'mg/dL'
            },
            {
                field: 'triglycerides',
                labelKey: 'userPage.measurements.triglycerides',
                unit: 'mg/dL'
            }
        ]
    },
    {
        type: 'glycemia',
        apiType: 'M_HBA1C',
        labelKey: 'userPage.measurements.glycemia',
        fields: [{ field: 'hba1c', label: 'HbA1c', unit: '%' }]
    },
    ...patientMeasurementTypes.map((measurement) => ({
        ...measurement,
        type: `clinical-${measurement.type}`,
        apiType: measurement.type,
        overviewAsSingleMetric: true
    }))
];
